import React from "react";
import styled from "styled-components";
import StyledToolTip from "./StyledToolTip";
import StyledReload from "./StyledReload";
import { formatDate, media } from "../../utils/helper";
import StyledText from "./StyledText";
import { useUser } from "../../hooks/useAuth";

export const TableContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.borderColor};
  border-radius: 5px;
  overflow: hidden;

  *::-webkit-scrollbar {
    width: 7px;
  }

  *::-webkit-scrollbar-track {
    background: #f6f6f6;
    border-radius: 4px;
  }

  *::-webkit-scrollbar-thumb {
    background: #dddddd;
    border-radius: 4px;
  }

  ${media.md`
    border: none;
  `}
`;

export const CustomTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TableHeader = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.tableHeader};
  color: ${({ theme }) => theme.colors.secondary};
  font-weight: 600;
  font-size: 0.8rem;
  padding: 12px 2rem 12px 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};

  ${media.md`
    display: none;
  `}
`;

export const TableBody = styled.div`
  max-height: 175px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  margin: 7px 10px 0;

  ${media.md`
    margin: 0;
    max-height: 16rem;
  `}
`;

export const TableRow = styled.div`
  display: flex;
  padding: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};

  &:last-child {
    border: none;
  }

  ${media.md`
    background-color: ${({ theme }) => theme.colors.body};
    margin: 7px 7px 0;
    border-bottom: none;
    
    ._two-items {
      flex-grow: 1;
    }
  `}
`;

export const TableCell = styled.div`
  flex: 1;
  text-align: center;

  &:first-child {
    text-align: left;
  }

  .cell-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 170px;
  }

  ${media.md`
    flex: 0;
    font-size: 14px;
    font-weight: 500;
    line-height: 25px;

    &:not(:first-child) {
      font-weight: 400;

      .cell-title {
        font-weight: 500;
      }
    }
  `}
`;

export const ActionCell = styled(TableCell)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const renderCellContent = (row, headerKey, cellAction, actions) => {
  if (headerKey === "value" && row.status === 'PENDING') {
    return (
      <span className="d-flex align-items-center gap-2">
        <span className="cell-text">{row[headerKey]}</span>
        <span className="d-none d-md-block">
          <StyledToolTip title="Pending Verification">
            {/* <StyledReload onChange={() => cellAction(row)} /> */}
            <StyledReload /> 
          </StyledToolTip>
        </span>

        <span className="d-block d-md-none">
          {/* <StyledReload
            onChange={() => actions.onPendingVerificationModal(row)}
          /> */}
           <StyledReload/>  
        </span>
      </span>
    );
  }
  if (headerKey === "createdAt") {
    return (
      <span className="d-flex align-items-center justify-content-start justify-content-md-center gap-2 text-center">
        <span className="d-flex d-md-none cell-title">Started Date:</span>
        <span className="cell-text">{formatDate(row[headerKey])}</span>
      </span>
    );
  } else {
    return <span className="cell-text">{row[headerKey]}</span>;
  }
};

const StyledTable = ({
  headers,
  data,
  actions,
  cellAction,
  callToFunc,
  ...props
}) => {
  const { user } = useUser();
  return (
    <TableContainer {...props}>
      <CustomTable>
        <TableHeader>
          {headers.map(({ label, key }) => (
            <TableCell key={key} className="__cell">
              {label}
            </TableCell>
          ))}
          {actions && <ActionCell>Actions</ActionCell>}
        </TableHeader>
        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {headers.map(({ key: headerKey }, index) => (
                <TableCell
                  className="d-none d-md-block"
                  key={headerKey + index}
                >
                  {renderCellContent(row, headerKey, cellAction, callToFunc)}
                </TableCell>
              ))}
              <div className="d-flex flex-column d-md-none _two-items">
                {headers.map(({ key: headerKey }, index) => (
                  <TableCell key={headerKey + index}>
                    {renderCellContent(row, headerKey, cellAction, callToFunc)}
                  </TableCell>
                ))}
              </div>
              {actions && (
                <ActionCell>
                  {actions.map((action, actionIndex) => (
                    <>
                      {user.email !== row.value && (
                        <StyledText
                          color="iconColor"
                          className="cursor-pointer"
                          key={actionIndex}
                          onClick={() => action.onClick(row)}
                        >
                          {action.label}
                        </StyledText>
                      )}
                    </>
                  ))}
                </ActionCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </CustomTable>
    </TableContainer>
  );
};

export default StyledTable;
